import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import config from '../config'

if (!firebase.apps.length) {
  firebase.initializeApp(config.firebaseClientCredentials)
}

firebase.auth().languageCode = 'es'

// Explicit LOCAL persistence — the compat default, but we declare it so the
// intent is clear and behaviour is robust against future SDK default changes.
// Errors (e.g. private-mode IndexedDB blocked) silently downgrade to in-memory
// session, which matches the desired graceful-degrade behaviour.
if (typeof window !== 'undefined') {
  firebase
    .auth()
    .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    .catch(() => {
      // Persistence unavailable (Safari private mode, restricted storage).
      // Fall back to in-memory; user just won't stay signed in across reloads.
    })
}

// App Check is NOT activated here on purpose — see `./appCheck.ts`.
// This module is imported by apollo-client's authLink and AuthProvider, i.e.
// by every visitor, so activating here loaded the reCAPTCHA script site-wide.
// Sign-in entry points call `ensureAppCheck()` explicitly instead.

export default firebase
